import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { toast } from "react-toastify";

class HledaniKlienta extends Component {
  state = {};

  rfid = "";
  cleaner = null;
  hledaniTimer = null;

  handleKeyDown = (e) => {
    let key = "";
    switch (e.key) {
      case "+":
        key = "1";
        break;
      case "ě":
        key = "2";
        break;
      case "š":
        key = "3";
        break;
      case "č":
        key = "4";
        break;
      case "ř":
        key = "5";
        break;
      case "ž":
        key = "6";
        break;
      case "ý":
        key = "7";
        break;
      case "á":
        key = "8";
        break;
      case "í":
        key = "9";
        break;
      case "é":
        key = "0";
        break;
      case "Shift":
        key = "";
        break;
      default:
        key = e.key;
        break;
    }
    if (this.cleaner) {
      clearTimeout(this.cleaner);
    }
    if (e.keyCode === 13) {
      this.overeni(this.rfid, true);
    } else if (key === "/") {
      this.rfid = "";
    } else {
      this.rfid += key;
    }
    console.log(this.rfid);
    this.cleaner = setTimeout(() => {
      this.rfid = "";
    }, 500);
  };

  overeni = async (rfid) => {
    if (rfid && rfid !== "") {
      const idpobytu = await httpService.post(
        config.apiEndpoint + "casovani/hledatChip.php",
        { rfid }
      );
      if (idpobytu.data && idpobytu.data.idpobytu) {
        await this.setState({ nalezeno: null, loaded: false, hledani: "" });
        window.location.href =
          "#/casovani/kartaKlienta/" + idpobytu.data.idpobytu;
      } else {
        toast.error("Chip nenalezen");
      }
    }
  };

  hledani = async (hledani) => {
    if (this.hledaniTimer) {
      clearTimeout(this.hledaniTimer);
    }
    this.setState({ hledani });
    this.hledaniTimer = setTimeout(() => this.hledatPobyty(), 500);
  };

  hledatPobyty = async () => {
    const { hledani } = this.state;
    const vysledek = await httpService.post(
      config.apiEndpoint + "casovani/hledatPobyty.php",
      { hledani }
    );
    this.setState({ nalezeno: vysledek.data.nalezeno, loaded: true });
  };

  componentDidMount = () => {
    document.addEventListener("keydown", this.handleKeyDown);
  };

  render() {
    const { nalezeno, loaded } = this.state;
    return (
      <div className="pb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Načtěte chip klienta, nebo ho vyhledejte podle jména/ID pobytu"
          onChange={(e) => this.hledani(e.target.value)}
          value={this.state.hledani}
        />
        {loaded ? (
          nalezeno && nalezeno.length > 0 ? (
            <table className="table primary-table">
              <thead>
                <tr>
                  <th>Jméno</th>
                  <th>Typ pobytu</th>
                  <th>Příchod</th>
                  <th>Odchod</th>
                </tr>
              </thead>
              <tbody>
                {nalezeno.map((n, index) => (
                  <tr key={index}>
                    <td>
                      <a href={"#/casovani/kartaKlienta/" + n.idpobytu}>
                        {n.jmeno}
                      </a>
                      , {n.mesto}
                    </td>
                    <td>{n.typPobytu}</td>
                    <td>{new Date(n.prichod).toLocaleDateString()}</td>
                    <td>{new Date(n.odchod).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="alert mt-2">Nic nenalezeno...</div>
          )
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default HledaniKlienta;
